import { Label } from '@/components/ui/label';

interface TProps {
  title: string;
  icon: React.ReactNode;
  label: string;
}

const SpecItem = ({ title, icon, label }: TProps) => (
  <div className='flex w-full items-center gap-3'>
    <div className='flex size-10 shrink-0 items-center justify-center rounded-xl bg-red-50'>
      {icon}
    </div>
    <div className='flex w-full flex-col gap-0.5'>
      <Label className='text-[11px] font-semibold tracking-wide text-zinc-400 uppercase'>
        {title}
      </Label>
      <Label className='w-full text-sm leading-snug font-semibold whitespace-normal text-zinc-900 lg:text-wrap'>
        {label}
      </Label>
    </div>
  </div>
);

export default SpecItem;
